import styles from "./sobre-section.module.css";
import empresaImg from "../../../images/_finais/ImagemEmpresa_compress.webp";
import { useNavigate } from "react-router-dom";

interface IProps {
  onHandlePages: any;
}

const SobreSection = ({ onHandlePages }: IProps) => {
  const navigate = useNavigate();

  const handleOnClickSobre = (newPage: string) => {
    onHandlePages(newPage);
    return navigate("/sobre");
  };

  return (
    <section className={styles.sobre_section}>
      <div className={styles.sobre_div}>
        <img
          className={styles.empresa_img}
          src={empresaImg}
          alt="Imagem Sobre a Empresa."
          loading="lazy"
        />
        <div className={styles.sobre_texts}>
          <h1 className={styles.sobre_title}>SOBRE A EMPRESA</h1>
          <span className={styles.line}></span>
          <p className={styles.sobre_paragraph}>
            A TruEvidence nasceu com o objetivo de dar suporte principalmente à
            indústria farmacêutica e instituições de saúde a criar e fazer uso
            das evidências científicas, particularmente Real-World Evidence
            (RWE) para implementação e monitoramento de novas tecnologias ou
            soluções estratégias para sua empresa.
          </p>
          <button
            className={styles.btn_leiaMais}
            onClick={() => handleOnClickSobre("SOBRE")}
          >
            LEIA MAIS
          </button>
        </div>
        <img
          className={styles.empresa_imgMobile}
          src={empresaImg}
          alt="Imagem Sobre a Empresa."
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default SobreSection;
